export const TOP_KEYWORDS_COLORS = ['#4E79A7', '#59A14F', '#E15759', '#F28E2B', '#8CD17D', '#D8DBE2'];
